/**
 * frontend/src/components/common/BackgroundShapes.js
 * 
 * Visual component that renders animated decorative shapes in the background.
 * Uses Framer Motion for continuous, slow-moving animations to provide a modern UI feel.
 */
import React from 'react';
import { motion } from 'framer-motion';

const BackgroundShapes = () => {
  return (
    <div className="bg-shapes">
      <motion.div
        className="shape shape-1"
        animate={{
          x: [0, 30, -20, 20, 0],
          y: [0, -30, 20, 30, 0],
          rotate: [0, 5, -5, 3, 0],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />
      <motion.div
        className="shape shape-2"
        animate={{
          x: [0, -20, 30, -30, 0],
          y: [0, 30, -20, 20, 0],
          rotate: [0, -5, 5, -3, 0],
        }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 2,
        }}
      />
    </div>
  );
};

export default BackgroundShapes;
